import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Scales01 = function Scales01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M2 17v-.1502c0-.3165 0-.4747.0242-.6289a2 2 0 0 1 .1064-.4007c.0555-.1459.134-.2833.291-.558L6 9m-4 8c0 2.2091 1.7909 4 4 4s4-1.7909 4-4m-8 0v-.2c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185C2.38 16 2.52 16 2.8 16h6.4c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185C10 16.38 10 16.52 10 16.8v.2M6 9l3.5784 6.2622c.157.2747.2355.4121.291.558.0492.1295.0849.2638.1064.4007.0242.1542.0242.3124.0242.6289V17M6 9l12-2m-4 8v-.1502c0-.3165 0-.4747.0242-.6289a2 2 0 0 1 .1064-.4007c.0555-.1459.134-.2833.291-.558L18 7m-4 8c0 2.2091 1.7909 4 4 4s4-1.7909 4-4m-8 0v-.2c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185C14.38 14 14.52 14 14.8 14h6.4c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185C22 14.38 22 14.52 22 14.8v.2m-4-8 3.5784 6.2622c.157.2747.2355.4121.291.558.0492.1295.0849.2638.1064.4007.0242.1542.0242.3124.0242.6289V15M12 3v5"
    })
  }));
};
export default Scales01;